export default class ClaimSelection {
  constructor() {
    this.claimSel = document.querySelector(".sel-cont");

    // If there is no selects, return
    if (this.claimSel == null) return;
    this.selections = this.claimSel.querySelectorAll("select");
    this.inputCompanyName = document.querySelector(".txtCompanyName");
    this.selectCompanyName = document.getElementById("ListCompanyNames");
    this.selectCompanyNameOuter = document.getElementById("ListCompanyNamesOuter");
    this.inputCompanyAddress = document.querySelector(".txtCompanyAddress");
    this.selectCompanyCity = document.getElementById("ListCompanyCities");
    this.selectCompanyCityOuter = document.getElementById("ListCompanyCitiesOuter");
    this.inputCompanyEmail = document.querySelector(".txtCompanyEmail");
    this.selectCompanyEmail = document.getElementById("ListCompanyEmails");
    this.selectCompanyEmailOuter = document.getElementById("ListCompanyEmailsOuter");

    /** Populate inputs with select values */
    this.selectCompanyName.addEventListener('change', setTimeout.bind(null, this.populateInput.bind(this), 500));
    this.selectCompanyCity.addEventListener('change', setTimeout.bind(null, this.populateInput.bind(this), 500));
    this.selectCompanyEmail.addEventListener('change', setTimeout.bind(null, this.populateInput.bind(this), 500));

    this.selectInput();
    /** Populate company, city and email dropdowns */
    this.selectCity();
    this.selectEmail();
    this.selectCompanyName.addEventListener('change', this.selectCity.bind(this));
    this.selectCompanyName.addEventListener('change', this.selectEmail.bind(this));
    this.selectCompanyCity.addEventListener('change', this.selectEmail.bind(this));
  }

  selectInput() {
    for (const sel of this.selections) {
      sel.addEventListener('change', () => {
        if(sel.value === "Fra Liste") {
          this.inputCompanyName.classList.add('hidden');
          this.inputCompanyAddress.classList.add('hidden');
          this.inputCompanyEmail.classList.add('hidden');
          this.selectCompanyNameOuter .classList.remove('hidden');
          this.selectCompanyCityOuter.classList.remove('hidden');
          this.selectCompanyEmailOuter.classList.remove('hidden');
          this.populateInput();
        } else {
          this.inputCompanyName.classList.remove('hidden');
          this.inputCompanyAddress.classList.remove('hidden');
          this.inputCompanyEmail.classList.remove('hidden');
          this.selectCompanyNameOuter .classList.add('hidden');
          this.selectCompanyCityOuter.classList.add('hidden');
          this.selectCompanyEmailOuter.classList.add('hidden');
          this.clearInput();
        }
      });
    }
  }

  populateInput() {
      this.inputCompanyName.value = this.selectCompanyName.value;
      this.inputCompanyAddress.value = this.selectCompanyCity.value;
      this.inputCompanyEmail.value = this.selectCompanyEmail.value;
  }
  clearInput() {
    this.inputCompanyName.value = '';
    this.inputCompanyAddress.value = '';
    this.inputCompanyEmail.value = '';
  }


  selectCity(){
    populate_city();
    function populate_city () {
      $('#ListCompanyCities option').hide().prop("selected","");
      $("#ListCompanyCities option").filter(function () {
        return $(this).data("company") == $("#ListCompanyNames").val();
      }).show();
      $("#ListCompanyCities option").filter(function () {
        return $(this).data("company") == $("#ListCompanyNames").val();
      }).eq(0).prop("selected","selected");

    }

  }

  selectEmail(){
    populate_email ();
    function populate_email () {
      $('#ListCompanyEmails option').hide().prop("selected","");
      $("#ListCompanyEmails option").filter(function () {
        return $(this).data("company") == $("#ListCompanyNames").val() && $(this).data("city") == $("#ListCompanyCities").val();
      }).show();
      $("#ListCompanyEmails option").filter(function () {
        return $(this).data("company") == $("#ListCompanyNames").val() && $(this).data("city") == $("#ListCompanyCities").val();
      }).eq(0).prop("selected","selected");

    }

  }

}

